import { z } from "zod"

import { documentSectionSchema } from "./document-section"

// Definition of the Document schema
export const documentSchema = z.object({
  /** Unique ID of this document */
  documentId: z.number().int(),
  /** Title of this document */
  documentTitle: z.string(),
  /** URL for Genability's archive of this document */
  archiveUrl: z.string().url(),
  /** URL for the original source document (if applicable) */
  sourceUrl: z.string().url().optional(),
  /** Type of source document */
  sourceContentType: z.string().optional(),
  /** ID of the LSE associated with this document */
  lseId: z.number().int(),
  /** Name of the LSE associated with this document */
  lseName: z.string(),
  /** ID of the territory associated with this document */
  territoryId: z.number().int(),
  /** Name of the territory associated with this document */
  territoryName: z.string(),
  /** The position of this document in all documents for the LSE */
  sequenceNumber: z.number().int(),
  /** The documentId of the parent document of
   * this document, if this document is part of a collection */
  parentDocumentId: z.number().int().optional(),
  /** Document sections, typically corresponding to specific tariffs */
  sections: z.array(documentSectionSchema),
  /** documentId of the document for the previous version of this tariff */
  priorDocumentId: z.number().int().optional(),
})

export type Document = z.infer<typeof documentSchema>
